import * as React from "react";
import { Flex, Callout as _Callout } from "@radix-ui/themes";

const TYPE_MAP = {
    note: {
        icon: "info",
        iconColor: "#8792a2",
        backgroundColor: "gray",
        borderColor: "var(--code-border)"
    },
    warning: {
        icon: "report",
        iconColor: "#d97917",
        backgroundColor: "amber",
        borderColor: "#e3e3a3"
    },
    check: {
        icon: "check_circle",
        iconColor: "var(--black)",
        backgroundColor: "green",
        borderColor: "#16a34a"
    },
    error: {
        icon: "error",
        iconColor: "var(--pink)",
        backgroundColor: "red",
        borderColor: "#ffc0d6"
    }
};

export function Callout({ title, children, type }) {
    const { icon, backgroundColor } = TYPE_MAP[type] || TYPE_MAP.note;

    return (
        <_Callout.Root variant="surface" color={backgroundColor}>
            <Flex gap="4" p="3" pl="1">
                <span className="material-symbols-rounded">{icon}</span>
                <div suppressHydrationWarning={true} className="flex column">
                    {(title && <strong>{title}</strong>)}
                    {children}
                </div>
            </Flex>
            <style jsx>
                {`
                @media screen and (max-width: 768px) {
                    .material-symbols-rounded {
                        display: none;
                    }
                }
                `}
            </style>
        </_Callout.Root>
    );
}
